import request from '@/utils/request'

export function login(username, password) {
  const domain = process.env.VUE_APP_LOGIN_URL
  return request({
    url: domain + '/shop/oauth/token',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/user',
    method: 'get'
  })
}

export function getMenu() {
  return request({
    url: '/permission/my/menu/list',
    method: 'get'
  })
}
